<template>
  <div class="content" id="pjax-container">
    <div class="row">
      <div class="col-md-6">
        <div class="block block-rounded h-100 mb-0">
          <div class="block-header block-header-default">
            <h3 class="block-title">账号密码添加（请使用云运动账号登录）</h3>
          </div>
          <div class="block-content">
            <form onsubmit="return false;" id="login-form">
              <div class="mb-4">
                <label class="form-label" for="login-username">学号</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="far fa-user"></i>
                  </span>
                  <input
                    v-model="account.userName"
                    type="text"
                    class="form-control"
                    id="login-username"
                    name="login-username"
                    placeholder="请输入手机号"
                  />
                </div>
              </div>
              <div class="mb-4">
                <label class="form-label" for="login-password">密码</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="far fa-surprise"></i>
                  </span>
                  <input
                    v-model="account.password"
                    type="password"
                    class="form-control"
                    id="login-password"
                    name="login-password"
                    placeholder="请输入密码"
                  />
                </div>
              </div>
              <div class="mb-4">
                <label class="form-label" for="school-select">学校</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="far fa-building"></i>
                  </span>
                  <el-select
                    v-model="account.schoolId"
                    filterable
                    size="large"
                    placeholder="请选择或搜索学校"
                    class="form-control p-0 el-select-custom"
                  >
                    <el-option
                      v-for="school in schools"
                      :key="school.schoolId"
                      :label="school.schoolName"
                      :value="school.schoolId"
                    />
                  </el-select>
                </div>
              </div>

              <div class="mb-4">
                <button
                  type="submit"
                  class="btn btn-alt-primary"
                  @click="add()"
                >
                  <i class="fa fa-arrow-right opacity-50 me-1"></i> 登录
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-1">
        <div
          class="alert alert-info d-flex align-items-center justify-content-between"
          role="alert"
        >
          <p class="mb-0">请使用云运动绑定的学号进行登录</p>
          <i class="fa fa-fw fa-info ms-2"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useMessage } from "@/hooks/useMessage"; // 假设你有这个 hook，如果没有需要相应调整
import { addYunUser } from "@/api/yun";
import schoolsData from "@/assets/schools.json";

const router = useRouter();
const message = useMessage();

const account = ref({
  schoolId: "",
  userName: "",
  password: "",
});

const schools = ref(schoolsData.schools);
console.log(schools);
const add = async () => {
  try {
    const msg = await addYunUser(account.value);
    message.success(msg);
    setTimeout(() => {
      router.push("/yun/list");
    }, 1000);
  } catch (e) {
    message.error(e.message);
  }
};
</script>

<style scoped>
.el-select-custom {
  border: none;
}
:deep(.el-input__wrapper) {
  border: none;
  box-shadow: none !important;
}
:deep(.el-input__inner) {
  height: 100%;
}
</style>
